import type { AnalyticsClient } from '@3plearning/mx-teacher-analytics';
import { useAnalytics as usePackageAnalytics } from '@3plearning/mx-teacher-analytics/react';

import type { AppEvents } from './events';

// The package hook throws without an <AnalyticsProvider>. Tests render
// components in isolation, so fall back to a no-op client there.
export const useAnalyticsClient = (): AnalyticsClient<AppEvents> | null => {
    try {
        return usePackageAnalytics<AppEvents>();
    } catch {
        return null;
    }
};
